import { forwardRef } from 'react';
import moment from 'moment';
import IcDot from '../../../../assets/image/report/ic_dots_btn.svg';
import { stripHtmlTags } from '../../../../utility/stripHtmlTag';
// import IcRightArrow from '../../../../assets/image/ic_chevron_right.svg';
// import IcComment from '../../../../assets/image/community/ic_comment.svg';
// import IcLike from '../../../../assets/image/community/ic_like.svg';

interface PostCardProps {
  post: any;
  onClick: (id: any) => void;
  onOptionClick: (id: any) => void;
}

const PostCard = forwardRef<HTMLDivElement, PostCardProps>(
  ({ post, onClick, onOptionClick }, ref) => {
    return (
      <div
        ref={ref}
        className="w-full flex flex-col gap-[12px] py-[12px] border-b border-[#eaeaea] cursor-pointer"
        onClick={() => onClick(post?.id)}
      >
        <div className="w-full flex items-start justify-end gap-[6px]">
          <div className="flex-1 flex flex-col gap-[8px] items-start justify-center min-w-0">
            <div className="w-full text-left font-['Pretendard',sans-serif] font-bold text-[16px] text-[#1c1c1c] leading-none tracking-[-0.32px] overflow-hidden text-ellipsis whitespace-nowrap">
              {post?.title}
            </div>
            <div className="w-full text-left font-['Pretendard',sans-serif] font-normal text-[12px] text-[#363636] leading-[1.6] overflow-hidden text-ellipsis line-clamp-2">
              {stripHtmlTags(post?.content)}
            </div>
          </div>
          <div className="flex items-center gap-[6px] shrink-0">
            {post?.isAnswered ? (
              <div className="bg-[#f0fcfc] flex items-center justify-center h-[22px] px-[8px] py-0 rounded-[100px]">
                <span className="font-['Pretendard',sans-serif] font-semibold text-[12px] text-[#42a9aa] leading-none tracking-[-0.24px]">
                  답변완료
                </span>
              </div>
            ) : (
              <div className="bg-[#f3f3f3] flex items-center justify-center h-[22px] px-[8px] py-0 rounded-[100px]">
                <span className="font-['Pretendard',sans-serif] font-semibold text-[12px] text-[#767676] leading-none tracking-[-0.24px]">
                  미답변
                </span>
              </div>
            )}
            <button
              type="button"
              className="w-[18px] h-[18px] flex items-center justify-center shrink-0"
              onClick={(e) => {
                e.stopPropagation();
                onOptionClick(post?.id);
              }}
            >
              <img src={IcDot} alt="more options" className="w-[18px] h-[18px]" />
            </button>
          </div>
        </div>
        <div className="w-full flex items-center gap-[12px]">
          <div className="font-['Pretendard',sans-serif] font-normal text-[12px] text-[#969696] leading-none">
            {moment(post?.createdAt).format('YY.MM.DD')}
          </div>
        </div>
      </div>
    );
  }
);

export default PostCard;
